import React from "react";
import kebabCase from "lodash/kebabCase";
import { Link } from "gatsby";
import PostPreview from "../PostPreview";
import {
  postList,
  postListTitle,
  postListPosts,
  postListInfo,
  postListContainer,
  postListTags,
} from "./styles.module.css";

const PostList = ({ posts, about, tags, hasTitle }) => {
  const { node: aboutNode } = about[0] || [];

  return (
    <div className={postList}>
      {hasTitle && <h2 className={postListTitle}>Recent Posts</h2>}
      <div className={postListContainer}>
        <div className={postListPosts}>
          {posts.map((node) => (
            <PostPreview post={node} />
          ))}
        </div>
        <div className={postListInfo}>
          <h3>Tags</h3>
          {tags.group.map((tag) => (
            <Link to={`/tags/${kebabCase(tag.tag)}`} className={postListTags}>
              {tag.tag}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PostList;
